module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: {
      'has-title': _vm.title, 'is-light': _vm.isLight
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.duration) ? _c('div', {
    staticClass: "countdown"
  }, [_c('div', {
    class: [_vm.duration.years ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.duration.years))]), _vm._v(" "), (_vm.duration.years == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Jahr")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Jahre")])]), _vm._v(" "), _c('div', {
    class: [_vm.months ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.months))]), _vm._v(" "), (_vm.months == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Monat")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Monate")])]), _vm._v(" "), _c('div', {
    class: [_vm.days ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.days))]), _vm._v(" "), (_vm.days == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Tag")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Tage")])]), _vm._v(" "), _c('div', {
    class: [_vm.hours ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hours))]), _vm._v(" "), (_vm.hours == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Stunde")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Stunden")])]), _vm._v(" "), _c('div', {
    class: [_vm.minutes ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.minutes))]), _vm._v(" "), (_vm.minutes == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Minute")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Minuten")])]), _vm._v(" "), _c('div', {
    class: [_vm.seconds ? 'tocome' : 'passed']
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.seconds))]), _vm._v(" "), (_vm.seconds == 1) ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Sekunde")]) : _c('span', {
    staticClass: "text"
  }, [_vm._v("Sekunden")])])]) : _c('div', {
    staticClass: "expired"
  }, [_c('span', [_vm._v("Der Countdown zum")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.targetDateFormatted))]), _vm._v(" "), _c('span', [_vm._v("ist abgelaufen.")])]), _vm._v(" "), _c('div', {
    staticClass: "debug"
  }, [_vm._v(_vm._s(_vm.resolution) + " | " + _vm._s(_vm.params.datetime))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c2a2ed","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateTime.vue
// module id = 150
// module chunks = 1